import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import Swiper from 'swiper';
import { Navigation, FreeMode, Thumbs } from 'swiper/modules';

document.querySelectorAll( '.etch-product-gallery' ).forEach( ( gallery ) => {
	const mainEl   = gallery.querySelector( '.etch-product-gallery__main' );
	const thumbsEl = gallery.querySelector( '.etch-product-gallery__thumbs' );

	if ( ! mainEl ) return;

	let thumbsSwiper = null;

	if ( thumbsEl ) {
		thumbsSwiper = new Swiper( thumbsEl, {
			modules:         [ FreeMode ],
			slidesPerView:   'auto',
			spaceBetween:    8,
			freeMode:        true,
			watchSlidesProgress: true,
		} );
	}

	new Swiper( mainEl, {
		modules:    [ Navigation, Thumbs ],
		loop:       false,
		navigation: {
			prevEl: gallery.querySelector( '.etch-gallery-nav--prev' ),
			nextEl: gallery.querySelector( '.etch-gallery-nav--next' ),
		},
		thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
	} );
} );
